import { ComponentProps, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../../../../shared/constants';
import { useCurrentUser } from '../../../../../shared/context';
import { Permission } from '../../../../../shared/enum';
import { Folder } from '../../models';
import { CopyFolderModal } from './copy-folder-modal.component';
import { DeleteFolderModal } from './delete-folder-modal.component';
import { FolderDropdownMenu } from './folder-dropdown-menu.component';
import { MoveFolderModal } from './move-folder-modal.component';

type FolderDropdownProps = {
  selectedFolder: Folder;
  currentFolders: Folder[];
  isSubFolder: boolean;
  size?: 'md' | 'sm';
  variant?: ComponentProps<typeof Button>['variant'];
  onRefetchFolderTree: () => void;
};

export const FolderDropdown = ({
  selectedFolder,
  currentFolders,
  size = 'md',
  variant = 'ghost',
  isSubFolder,
  onRefetchFolderTree,
}: FolderDropdownProps) => {
  const { permissions } = useCurrentUser();
  const history = useHistory();

  const [showCopyFolderModal, setShowCopyFolderModal] = useState(false);
  const [showMoveFolderModal, setShowMoveFolderModal] = useState(false);
  const [showDeleteFolderModal, setShowDeleteFolderModal] = useState(false);

  const canCopyFolder = isSubFolder
    ? permissions.includes(Permission.CopyFolder)
    : permissions.includes(Permission.ManageMainFolders);

  const showFolderDropdown =
    canCopyFolder ||
    (isSubFolder && permissions.includes(Permission.ManageFolders)) ||
    permissions.includes(Permission.DeleteFolder);

  const onDeletFolderSuccess = () => {
    onRefetchFolderTree();
    if (!isSubFolder) {
      history.push(PATHS.DocumentsHome);
    }
  };

  return (
    <>
      {showFolderDropdown && (
        <FolderDropdownMenu
          canCopyFolder={canCopyFolder}
          isSubFolder={isSubFolder}
          selectedFolder={selectedFolder}
          variant={variant}
          size={size}
          onShowCopyModal={() => setShowCopyFolderModal(true)}
          onShowMoveModal={() => setShowMoveFolderModal(true)}
          onShowDeleteModal={() => setShowDeleteFolderModal(true)}
        />
      )}

      <CopyFolderModal
        isOpen={showCopyFolderModal}
        isSubFolder={isSubFolder}
        selectedFolder={selectedFolder}
        currentFolders={currentFolders}
        onCloseModal={() => setShowCopyFolderModal(false)}
      />

      <MoveFolderModal
        isOpen={showMoveFolderModal}
        selectedFolder={selectedFolder}
        onSuccess={onRefetchFolderTree}
        onCloseModal={() => setShowMoveFolderModal(false)}
      />

      <DeleteFolderModal
        isOpen={showDeleteFolderModal}
        selectedFolder={selectedFolder}
        onSuccess={onDeletFolderSuccess}
        onCloseModal={() => setShowDeleteFolderModal(false)}
      />
    </>
  );
};
